import arrow_next from "./arrow-next-outline.svg";
import arrow_prev from "./arrow-prev-outline.svg";
import chevronRight from "./chevronRight.svg";
export default { arrow_next, arrow_prev, chevronRight };
